import React, { useState } from 'react';
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCityStateTextField,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelect,
  CustomTextFeild,
} from '../../common/StyledComponents/StyledFields';
import { Box, FormControl, Grid, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import styles from './vendor.module.scss';
import { ValidationError, object, string } from 'yup';
import { apiRequest, catchErrorMessageHandler } from '../../../infrastructure/backendService';
import { isEmpty } from 'lodash';
import apiPath from '../../../config/apiPaths.json';

interface ErrorMessageTypes {
  vendorName: string;
  zipcode: string;
  phoneNumber: string;
  email: string;
  state: string;
  country: string;
  paymentMethod: string;
  address: string;
  service: string;
  fax: string;
  city: string;
}
const VendorsForm = () => {
  const formFields = {
    vendorName: '',
    zipcode: '',
    phoneNumber: '',
    email: '',
    state: '',
    country: '',
    paymentMethod: '',
    address: '',
    service: '',
    fax: '',
    city: '',
  };
  const [formData, setFormData] = useState({
    ...formFields,
  });
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    ...formFields,
  });

  const validationSchema = object().shape({
    vendorName: string().required('Vendor Name is Required'),
    zipcode: string().required('ZipCode is Required'),
    phoneNumber: string().required('Phone Number is Required'),
    email: string().required('Email is Required'),
    city: string().required('City is Required'),
    address: string().required('City is Required'),
    fax: string().required('Fax is Required'),
    paymentMethod: string().required('Payment Method is Required'),
    service: string().required('service is Required'),
    country: string().required('Country is Required'),
    state: string().required('State is Required'),
  });


  const zipCodeApi = () => {
    if (formData.zipcode === "") {
      setErrorMessage({
        ...errorMessage,
        zipcode: "Please Enter Zipcode",
      });
    } else {
      apiRequest({
        method: "GET",
        endpoint: apiPath.cityAndStateApi,
        params: {
          zip: formData.zipcode,
        },
      })
        .then((res) => {
          setFormData({
            ...formData,
            state: res.data.stateName,
            city: res.data.city,
          });
        })
        .catch((err) => {
          setErrorMessage({
            ...errorMessage,
            zipcode: catchErrorMessageHandler(err),
          });
          setFormData({
            ...formData,
            state: "",
            city: "",
          });
        });
    }
  };
  const saveApiCall = () => {
    const reqBody = {};
    apiRequest({
      method: 'POST',
      endpoint: '/',
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        // const successMessage = LOCALE.DEATILS_UPDATED;
        // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
        //   duration: 3000,
        // });
        // toast.custom(
        //   <SuccessPopup
        //     headerMessage="Updated Profile"
        //     showMessage={successMessage}
        //     isOpen={isOpen}
        //     setIsOpen={setIsOpen}
        //   />,
        //   {
        //     duration: 3000,
        //   }
        // );
      })
      .catch((err) => {
        // toast.custom(
        //   <ErrorPopup
        //     showMessage={catchErrorMessageHandler(err)}
        //     isOpen={isOpen}
        //     setIsOpen={setIsOpen}
        //   />,
        //   {
        //     duration: constants.TOAST_POPUP_DURATION,
        //   }
        // );
      });
  };
  const handleSave = async (): Promise<void> => {
    const errors: ErrorMessageTypes = { ...formFields };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      saveApiCall();
    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };
  const handleFieldChange = (field: string, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };
  const StateDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: '100%' }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          value={formData.state}
          onChange={(e) => {
            handleFieldChange("state", e.target.value);
            setErrorMessage({ ...errorMessage, state: "" })
          }
          }
          className={errorMessage.state ? styles.errorTextField : styles.dropdownStyle}
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {/* {languageItems.map((item: any, index) => (
            <CustomMenuItem key={index} value={item.name}>
              {item.name}
            </CustomMenuItem>
          ))} */}
        </CustomSelect>
        {!isEmpty(errorMessage.state) && (
          <Typography sx={{ color: 'red', fontSize: '12px' }}>{errorMessage.state}</Typography>
        )}
      </FormControl>
    );
  };
  const countryDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: '100%' }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          value={formData.country}
          onChange={(e) => {
            handleFieldChange("country", e.target.value);
            setErrorMessage({ ...errorMessage, country: "" })
          }
          }
          className={errorMessage.country ? styles.errorTextField : styles.dropdownStyle}
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {/* {languageItems.map((item: any, index) => (
            <CustomMenuItem key={index} value={item.name}>
              {item.name}
            </CustomMenuItem>
          ))} */}
        </CustomSelect>
        {!isEmpty(errorMessage.country) && (
          <Typography sx={{ color: 'red', fontSize: '12px' }}>
            {errorMessage.country}
          </Typography>
        )}
      </FormControl>
    );
  };
  const paymentMethodDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: '100%' }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          value={formData.paymentMethod}
          onChange={(e) => {
            handleFieldChange('paymentMethod', e.target.value);
            setErrorMessage({ ...errorMessage, paymentMethod: '' });
          }}
          className={errorMessage.paymentMethod ? styles.errorTextField : styles.dropdownStyle}
          MenuProps={{
            PaperProps: {
              sx: {
                border: '1px solid #F05802',
                '& ul': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: 'auto',
                  minHeight: 'auto',
                  maxHeight: '300px',
                  '&::-webkit-scrollbar': {
                    width: '8px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: '#F3C539',
                    borderRadius: '6px',
                  },
                },
              },
            },
          }}
        >
          {/* {languageItems.map((item: any, index) => (
            <CustomMenuItem key={index} value={item.name}>
              {item.name}
            </CustomMenuItem>
          ))} */}
        </CustomSelect>
        {!isEmpty(errorMessage.paymentMethod) && (
          <Typography sx={{ color: 'red', fontSize: '12px' }}>
            {errorMessage.paymentMethod}
          </Typography>
        )}
      </FormControl>
    );
  };
  return (
    <div className={styles.formLayout}>
      <Typography component="div" className={styles.typoGraphyHeading}>
        Add New Vendor
      </Typography>
      <Grid className={styles.formContainer}>
        <Grid container spacing={2} sx={{ marginTop: '0px' }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Vendor Name', true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.vendorName}
              onChange={(e) => {
                handleFieldChange('vendorName', e.target.value);
                setErrorMessage({ ...errorMessage, vendorName: '' });
              }}
              className={errorMessage.vendorName ? styles.errorTextField : styles.textField}
              placeholder="Vendor Name"
            />
            {!isEmpty(errorMessage.vendorName) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.vendorName}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Zip Code', true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.zipcode}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Only allow numbers
                const sanitizedInput = inputValue.replace(/[^0-9]/g, '').slice(0, 10);
                handleFieldChange('zipcode', sanitizedInput);
                setErrorMessage({ ...errorMessage, zipcode: '' });
              }}
              className={errorMessage.zipcode ? styles.errorTextField : styles.textField}
              // onBlur={zipCodeApi}
              placeholder="Enter Zipcode"
              onBlur={zipCodeApi}
            />
            {!isEmpty(errorMessage.zipcode) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.zipcode}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('City', true)}
            <CustomCityStateTextField
              fullWidth
              required
              value={formData.city}
              onChange={(e) => {
                handleFieldChange('city', e.target.value);
                setErrorMessage({ ...errorMessage, city: '' });
              }}
              className={errorMessage.city ? styles.errorTextField : styles.textField}
              InputProps={{
                readOnly: true,
              }}
            />
            {!isEmpty(errorMessage.city) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.city}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: '0px' }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('State', true)}
            {StateDropdown()}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Country', true)}
            {countryDropdown()}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Address', false)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.address}
              onChange={(e: any) => {
                handleFieldChange('address', e.target.value);
                setErrorMessage({ ...errorMessage, address: '' });
              }}
              className={errorMessage.address ? styles.errorTextField : styles.textField}
              placeholder="Enter Address"
            />
            {!isEmpty(errorMessage.address) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.address}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: '0px' }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Phone', true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.phoneNumber}
              onChange={(e) => {
                handleFieldChange('phoneNumber', e.target.value);
                setErrorMessage({ ...errorMessage, phoneNumber: '' });
              }}
              className={errorMessage.phoneNumber ? styles.errorTextField : styles.textField}
              placeholder="Phone Number"
            />
            {!isEmpty(errorMessage.phoneNumber) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.phoneNumber}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Fax', true)}
            <CustomTextFeild
              fullWidth
              required
              value={formData.fax}
              onChange={(e) => {
                console.log(e, "eee")
                handleFieldChange("fax", e.target.value)
                setErrorMessage({...errorMessage, fax: '' })
              }}
              className={errorMessage.fax ? styles.errorTextField : styles.textField}
              placeholder="Fax"
            />
            {!isEmpty(errorMessage.fax) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.fax}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Email', true)}
            <CustomCityStateTextField
              fullWidth
              required
              value={formData.email}
              onChange={(e) => {
                handleFieldChange('email', e.target.value);
                setErrorMessage({ ...errorMessage, email: '' });
              }}
              className={errorMessage.email ? styles.errorTextField : styles.textField}
            />
            {!isEmpty(errorMessage.email) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.email}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: '0px' }}>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Utility/Commodity/Service', true)}
            <CustomCityStateTextField
              fullWidth
              required
              value={formData.service}
              onChange={(e) => {
                handleFieldChange('service', e.target.value);
                setErrorMessage({ ...errorMessage, service: '' });
              }}
              className={errorMessage.city ? styles.errorTextField : styles.textField}
            />
            {!isEmpty(errorMessage.service) && (
              <Typography sx={{ color: 'red', fontSize: '12px' }}>
                {errorMessage.service}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            {CustomRequiredInputLabel('Payement Method', true)}
            {paymentMethodDropdown()}
          </Grid>
        </Grid>
      </Grid>
      <Box sx={{ marginTop: '20px' }}>
        <Grid sx={{ display: 'flex', gap: '10px' }}>
          <CommonButton onClick={handleSave}>Submit</CommonButton>
          <CommonOutlinedButton>Cancel</CommonOutlinedButton>
        </Grid>
      </Box>
    </div>
  );
};
export default VendorsForm;
